export const servicesVariables = {
  xrfEnitrUnitNegative: process.env.REACT_APP_XRFENTIRUNIT * 1,
  xrfEnitrUnitPositive: process.env.REACT_APP_XRFENTIRUNIT * 1,
  xrfFrictionPositive: process.env.REACT_APP_XRFFRICTION * 1,
  xrfFrictionNegative: process.env.REACT_APP_XRFFRICTION * 1,
  dustWipe: process.env.REACT_APP_DUSTWIPE * 1,
  paintChip: process.env.REACT_APP_PAINTCHIP * 1,
  moldAssessment: process.env.REACT_APP_MOLD_INITIAL * 1,
  moldPostAssessment: process.env.REACT_APP_MOLD_POST_IN * 1,
};

export const moldInspectionServices = [process.env.REACT_APP_MOLD_POST_IN * 1, process.env.REACT_APP_MOLD_INITIAL * 1];

export const showAffedevitForServices = [1, 2, 5];
